
const buttonBase = {
  padding: '10px 20px',
  border: 'none',
  borderRadius: '8px',
  cursor: 'pointer',
  fontSize: '0.875rem',
  fontWeight: '500',
  transition: 'all 0.2s',
  minWidth: '120px',
  textAlign: 'center'
};

const buttonInTitleMenuBase = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    borderRadius: '4px',
    border: '1px solid #e0e0e0',
    backgroundColor: 'white',
    color: '#0C3058',
    cursor: 'pointer',
    transition: 'all 0.2s',
};

export const editButtonInTitleMenu = {
    ...buttonInTitleMenuBase,
    '&:hover': {
        backgroundColor: '#e3f2fd',
        color: '#1976d2',
        borderColor: '#bbdefb',
    }
};

export const deleteButtonInTitleMenu = {
    ...buttonInTitleMenuBase,
    '&:hover': {
        backgroundColor: '#ffebee',
        color: '#d32f2f',
        borderColor: '#ffcdd2',
    }
};

export const confirmButton = {
  ...buttonBase,
  backgroundColor: '#103C6E',
  color: 'white',  
};

export const cancelButton = {
    ...buttonBase,
    backgroundColor: '#fff',
    color: '#103c6e',
    border: '1px solid #103C6E'
};

export const pageActionsContainer = {
    display: 'flex',
    justifyContent: 'center',
    gap: '1rem',
    marginTop: '2rem'
}

